import { gql } from '@apollo/client';

export const CREATE_OR_UPDATE_LOGS = gql`
  mutation CreateOrUpdateLogs(
    $completePercent: String!,
    $complete: Int,
    $log_data: String
    $note: String
    $person_id: ID
    $type: String!
    $welds_id: [Int]!
    $date: String
    $inspection_category_type_id: ID
    $weld_failed: Int
    $double_length: Boolean
    $gauging: Boolean
    $skipped: Boolean
    $welding_consumables: [String]
    $wps_ids: [Int]
  ) {
    createOrUpdateLogs(
      complete_percent: $completePercent  
      complete: $complete
      log_data: $log_data
      note: $note
      person_id: $person_id
      type: $type
      welds_id: $welds_id
      date: $date
      inspection_category_type_id: $inspection_category_type_id
      weld_failed: $weld_failed
      double_length: $double_length
      gauging: $gauging
      skipped: $skipped
      welding_consumables: $welding_consumables
      wps_ids: $wps_ids
    ) {
      logs {
        errors
        log_data
        type
        weld_failed
        double_length
        gauging
        complete
        complete_percent
        note
        date
        created_at
        updated_at
      }
    }
  }
`;
